namespace GeniuzPOS.Administration {
    export class LanguageColumns {
        static columnsKey = 'Administration.Language';
    }
}
